export default __webpack_public_path__ + "static/media/threeSeaterCouch.8aecb492.svg";